import { GTE_651 } from './version';

export const APP_NAME = `快对${GTE_651 ? 'AI' : ''}`;